import { render, staticRenderFns } from "./AddEditBlockedDate.vue?vue&type=template&id=1237758c&"
import script from "./AddEditBlockedDate.vue?vue&type=script&lang=ts&"
export * from "./AddEditBlockedDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports